/**
 * Determines if the environment is production.
 *
 * @returns `true` if the environment is production otherwise `false`.
 */
export function isProd(): boolean {
  return process.env.BRANCH === 'main' || process.env.GATSBY_PUP_ENV === 'PROD';
}

/**
 * Determines if the environment is dev.
 *
 * @returns `true` if the environment is dev otherwise `false`.
 */
export function isDev(): boolean {
  return process.env.GATSBY_SITE_URL.includes('dev');
}

/**
 * Determines if the environment is the server.
 *
 * @returns `true` if the environment is server otherwise `false`.
 */
export function isServer(): boolean {
  return typeof window === 'undefined';
}
